<app-dashboard-container
	class="dashboard-overgang"
	[factTable]="factTable"
	(doExport)="this.doExport(filterExpressions(), permanentFilterExpressions, $event)"
>
	<app-filter-panel
		[defaultFilters]="variant() === DashboardVariant.ACTUEEL ? actueelFilters : historieFilters"
		[allFilters]="allFilters()"
		(filterExpressionsChange)="filterExpressions.set($event)"
		endpoint="/doorstroom"
		[permanentFilterExpressions]="permanentFilterExpressions"
	>
	</app-filter-panel>
	<app-filter-bar [dataRootSelection]="dataRootSelection()"></app-filter-bar>
	<section class="dashboard">
		<app-dashboard-header>
			<app-toggle-buttons [options]="varianten" [value]="variant()" (valueChange)="qp.dispatch('variant', $event)"></app-toggle-buttons>
			@if (variant() === DashboardVariant.HISTORIE) {
				<app-weergave-optie label="Eenheid" param="eenheid" [value]="eenheid()" [enum]="Eenheid"></app-weergave-optie>
			}
			<app-legenda class="cl-header-utility" [attribute]="['x_met_overgang']"></app-legenda>
		</app-dashboard-header>
		@switch (variant()) {
			@case (DashboardVariant.ACTUEEL) {
				<app-barchart-table
					[groups]="groups()"
					[filters]="filterExpressions()"
					[permanentFilters]="permanentFilterExpressions"
					[config]="this"
				></app-barchart-table>
			}
			@case (DashboardVariant.HISTORIE) {
				<app-vbarchart-table
					[groups]="historieGroups()"
					[subgroups]="historieSubgroups()"
					[filters]="filterExpressions()"
					[permanentFilters]="permanentFilterExpressions"
					[batchLevels]="1"
					[config]="this"
					[schooljaarPath]="['ds_nm_schooljaar_van']"
					[partitionMeasure]="partitionMeasure()"
				></app-vbarchart-table>
			}
		}
	</section>
</app-dashboard-container>
